"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ManageMessage = exports.MESSAGE_HOOK_MAP = void 0;
var _log = require("./log");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var noop = function noop() {};
var MESSAGE_HOOK_MAP = exports.MESSAGE_HOOK_MAP = {
  close: 'close',
  openNewTab: 'openNewTab',
  replaceCurrentPage: 'replaceCurrentPage',
  showClose: 'showClose',
  hiddenClose: 'hiddenClose',
  showLoading: 'showLoading'
};
var ManageMessage = exports.ManageMessage = /*#__PURE__*/function () {
  function ManageMessage() {
    var _this = this;
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    _classCallCheck(this, ManageMessage);
    _defineProperty(this, "callbackList", []);
    _defineProperty(this, "originRegExp", null);
    _defineProperty(this, "messageCallback", function (event) {
      var _this$originRegExp$te, _this$originRegExp, _event$origin, _event$origin$toLower;
      (0, _log.logger)('[management-message] receive data:', event.data, event.origin);
      if (_this.originRegExp && !((_this$originRegExp$te = (_this$originRegExp = _this.originRegExp).test) !== null && _this$originRegExp$te !== void 0 && _this$originRegExp$te.call(_this$originRegExp, (_event$origin = event.origin) === null || _event$origin === void 0 || (_event$origin$toLower = _event$origin.toLowerCase) === null || _event$origin$toLower === void 0 ? void 0 : _event$origin$toLower.call(_event$origin)))) {
        return;
      }
      if (_this.callbackList.length > 0) {
        _this.callbackList.forEach(function (callback) {
          return callback === null || callback === void 0 ? void 0 : callback(event);
        });
      }
    });
    this.callbackList = [];
    this.originRegExp = options === null || options === void 0 ? void 0 : options.originRegExp;
  }
  return _createClass(ManageMessage, [{
    key: "registry",
    value: function registry() {
      window.addEventListener('message', this.messageCallback, false);
      return this;
    }
  }, {
    key: "unRegistry",
    value: function unRegistry() {
      this.callbackList = [];
      window.removeEventListener('message', this.messageCallback, false);
      return this;
    }
  }, {
    key: "listen",
    value: function listen() {
      var callback = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : noop;
      this.callbackList.push(callback);
    }
  }]);
}();